export enum DynamicGroupEvent {
    ADDED = 'added',
}
